import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab16',
  templateUrl: './awsop-lab16.component.html',
  styleUrls: ['./awsop-lab16.component.css']
})
export class AwsopLab16Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab16/awsop-lab16.component.ts